<style scoped lang="scss">
.Withdrawal-content-div {
    height: 100vh;
    background: #f0f1f5;
    background-image:
        radial-gradient(circle at 20% 50%, rgba(99, 102, 241, 0.03) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(236, 72, 153, 0.03) 0%, transparent 50%);
}

.pagination {
    margin: 1.5rem auto 0;
    width: fit-content;
}

.Withdrawal_data {
    min-height: 70vh;
}

.Withdrawal-header {
    font-weight: 500;
    cursor: pointer;
}

.liu-text-success {
    color: #059669;
    font-weight: 500;
    font-size: 0.875rem;
}

.liu-text-danger {
    color: #dc2626;
    font-weight: 500;
    font-size: 0.875rem;
}

.liu-text-waring {
    color: #d97706;
    font-weight: 500;
    font-size: 0.875rem;
}

@media screen and (max-width: 768px) {
    .Withdrawal_data-div {
        min-width: fit-content;
        margin-left: 0.5rem;
        width: calc(100% - 1rem);
        background-color: white;
        padding: 1rem;
        margin-top: 1rem;
        border-radius: 8px;
        border: 1px solid #e5e7eb;
        box-shadow:
            0 1px 3px rgba(0, 0, 0, 0.04),
            0 4px 12px rgba(0, 0, 0, 0.04);
    }

    .Withdrawal-content-div {
        min-width: fit-content;
    }
}

@media screen and (min-width: 768px) {
    .Withdrawal_data-div {
        min-width: calc(100% - 4rem);
        margin-left: 2rem;
        width: calc(100% - 4rem);
        background-color: white;
        padding-bottom: 1.5rem;
        margin-top: 1.5rem;
        border-radius: 8px;
        border: 1px solid #e5e7eb;
        box-shadow:
            0 1px 3px rgba(0, 0, 0, 0.04),
            0 4px 12px rgba(0, 0, 0, 0.04);
    }

    .Withdrawal_data {
        min-width: calc(100% - 4rem);
    }
}

:deep(.el-table) {
    --el-table-border-color: #e5e7eb;
    --el-table-header-bg-color: #f9fafb;

    th {
        background: #f9fafb;
        font-weight: 600;
        color: #111827;
        font-size: 0.875rem;
        padding: 1rem;
        border-bottom: 1px solid #e5e7eb;
    }

    td {
        color: #374151;
        font-size: 0.875rem;
        padding: 1rem;
        font-weight: 500;
        border-bottom: 1px solid #f3f4f6;
    }

    tr:hover {
        td {
            background: #f9fafb;
        }
    }
}

:deep(.el-button) {
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.15s ease;
}

:deep(.el-button--success) {
    background: #059669;
    border: none;

    &:hover {
        background: #047857;
    }
}

:deep(.el-button--primary) {
    background: #6366f1;
    border: none;

    &:hover {
        background: #4f46e5;
    }
}

:deep(.el-pagination__total),
:deep(.el-pagination__sizes) {
    margin-right: 1rem;
    font-size: 0.875rem;
    color: #6b7280;
}

:deep(.btn-prev),
:deep(.btn-next) {
    background: white;
    border-radius: 6px;
    border: 1px solid #e5e7eb;

    &:hover {
        background: #f9fafb;
    }
}

:deep(.el-pager li) {
    background: white;
    border-radius: 6px;
    border: 1px solid #e5e7eb;

    &:hover {
        background: #f9fafb;
    }

    &.is-active {
        background: #6366f1;
        color: white;
        border-color: #6366f1;
    }
}

:deep(.el-dialog) {
    border-radius: 8px;
}

:deep(.el-form-item__label) {
    font-weight: 500;
    color: #374151;
    font-size: 0.875rem;
}

:deep(.el-input__wrapper) {
    background: #ffffff;
    box-shadow: 0 0 0 1px #d1d5db;
    transition: box-shadow 0.15s ease;
    border-radius: 6px;
    padding: 0 0.75rem;
    height: 2.5rem;

    &:hover {
        box-shadow: 0 0 0 1px #9ca3af;
    }

    &:focus-within {
        box-shadow: 0 0 0 2px #6366f1;
    }
}

:deep(.el-textarea__inner) {
    border-radius: 6px;
    border: 1px solid #d1d5db;

    &:hover {
        border-color: #9ca3af;
    }

    &:focus {
        border-color: #6366f1;
        box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);
    }
}

:deep(.el-select__wrapper) {
    border-radius: 6px;
}

:deep(.el-dialog) {
    border-radius: 8px;

    .el-dialog__header {
        padding: 1.25rem 1.5rem 0.75rem;
        border-bottom: 1px solid #f0f0f2;
        margin-right: 0;

        .el-dialog__title {
            font-size: 1.125rem;
            font-weight: 600;
            color: #111827;
        }

        .el-dialog__headerbtn {
            top: 1.25rem;
            right: 1.5rem;
            width: 2rem;
            height: 2rem;

            .el-dialog__close {
                font-size: 1.125rem;
                color: #9ca3af;

                &:hover {
                    color: #6366f1;
                }
            }
        }
    }

    .el-dialog__body {
        padding: 1.5rem;
    }

    .el-dialog__footer {
        padding: 0.875rem 1.5rem 1.25rem;
        border-top: 1px solid #f0f0f2;
    }
}

:deep(.el-form) {
    .el-form-item {
        margin-bottom: 1.25rem;

        &:last-child {
            margin-bottom: 0;
        }

        .el-form-item__label {
            font-weight: 500;
            color: #374151;
            font-size: 0.875rem;
            margin-bottom: 0.5rem;
            padding: 0;
            line-height: 1.5;
        }

        .el-input,
        .el-textarea,
        .el-select {
            width: 100%;
        }
    }
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;

    .el-button {
        min-width: 6rem;
        height: 2.375rem;
        font-size: 0.875rem;
        font-weight: 500;
        border-radius: 6px;
        transition: all 0.15s ease;

        &.el-button--default {
            background: #fff;
            border: 1px solid #e5e7eb;
            color: #374151;

            &:hover {
                background: #f9fafb;
                border-color: #d1d5db;
                color: #111827;
            }
        }

        &.el-button--primary {
            background: #6366f1;
            border: none;
            color: #fff;

            &:hover {
                background: #4f46e5;
            }
        }
    }
}
</style>

<template>
    <div class="common-layout"><el-container><el-aside style="width: fit-content;">
                <UserHead />
            </el-aside><el-container><el-header style="padding: 0;">
                    <HeadTop />
                </el-header><el-main
                    style="padding-top: 0;height: 100vh;overflow: auto;padding-left: 0;background-color: rgb(242, 242, 242) !important;">
                    <div class="Withdrawal-content-div">
                        <div style="margin-bottom: 3rem;">
                            <div class="Withdrawal_data-div rounded shadow">
                                <div class="Withdrawal-header"><el-button type="success"
                                        class="addEmpower-btn  mt-4 mb-3 ml-5"
                                        @click="applyWithdrawal('dialog')">申请提现</el-button></div><el-table
                                    :data="Withdrawal_data" class="Withdrawal_data"><el-table-column prop="id"
                                        label="id" /><el-table-column prop="money" label="提现金额"><template
                                            #default="scope">
                                            <div
                                                :class="{ 'liu-text-danger': scope.row.state == -1, 'liu-text-success': scope.row.state == 1 }">
                                                {{ scope.row.money }} 元 </div>
                                        </template></el-table-column><el-table-column style="z-index: 9999;" prop="skm"
                                        label="收款码"><template v-slot="scope">
                                            <div style="z-index: 9999;" class="demo-image__preview"><el-image
                                                    :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
                                                    :src="scope.row.skm"
                                                    style="width: 100px; height: 100px;z-index: 9999;" /></div>
                                        </template></el-table-column><el-table-column prop="act" label="提现方式"><template
                                            v-slot="scope">
                                            <div v-if="scope.row.act == 'wx'">微信</div>
                                            <div v-else-if="scope.row.act == 'zfb'">支付宝</div>
                                            <div v-else>未知</div>
                                        </template></el-table-column><el-table-column prop="remarks"
                                        label="备注"></el-table-column><el-table-column prop="state" label="状态"><template
                                            v-slot="scope">
                                            <div
                                                :class="{ 'liu-text-waring': scope.row.state == 0, 'liu-text-success': scope.row.state == 1, 'liu-text-danger': scope.row.state == -1 }">
                                                {{ getWithdrawalAct(scope.row.state) }}
                                            </div>
                                        </template></el-table-column><el-table-column prop="res_code"
                                        label="处理结果"><template v-slot="scope">
                                            <div v-if="!isNull(scope.row.res_code)">{{ scope.row.res_code }}</div>
                                            <div v-else>无</div>
                                        </template></el-table-column><el-table-column prop="add_time"
                                        label="申请时间" /><el-table-column prop="end_time" label="处理时间"><template
                                            v-slot="scope">
                                            <div v-if="!isNull(scope.row.end_time)">{{ scope.row.end_time }}</div>
                                            <div v-else>无</div>
                                        </template></el-table-column></el-table><el-pagination class="pagination"
                                    v-model:current-page="Withdrawal_Conf.currentPage"
                                    v-model:page-size="Withdrawal_Conf.pageSize" :page-sizes="[10, 25, 50]"
                                    :small="small" :disabled="disabled" :background="background"
                                    layout="total, sizes, prev, pager, next, jumper" :total="Withdrawal_Conf.total"
                                    @size-change="WithdrawalSizeChange" @current-change="WithdrawalCurrentChange" />
                            </div>
                        </div>
                    </div><el-dialog :close-on-click-modal="false" v-model="Withdrawal_Dialog.Visible" title="申请提现"
                        width="540"><el-form :model="Withdrawal_Dialog.from" label-position="top"><el-form-item
                                label="提现金额"><el-input type="number" :max="Withdrawal_Dialog.maxMoney"
                                    v-model="Withdrawal_Dialog.from.money" autocomplete="off"
                                    placeholder="请输入提现金额" /></el-form-item><el-form-item label="选择收款方式"><el-select
                                    v-model="Withdrawal_Dialog.from.selectAct" placeholder="--请选择--"><el-option
                                        v-for="(item, i) in Withdrawal_Dialog.from.skAct" :key="i" :label="item.str"
                                        :value="item.act" /></el-select></el-form-item><el-form-item
                                label="备注"><el-input rows="4" type="textarea" v-model="Withdrawal_Dialog.from.remarks"
                                    autocomplete="off" placeholder="请输入备注信息（选填）" /></el-form-item></el-form><template
                            #footer>
                            <div class="dialog-footer"><el-button
                                    @click="Withdrawal_Dialog.Visible = false">关闭</el-button><el-button type="primary"
                                    @click="applyWithdrawal('apply')">申请提现</el-button></div>
                        </template></el-dialog>
                </el-main></el-container></el-container>
    </div>
</template>
<script>import {
    defineComponent
}

    from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';

import {
    isLogin,
    isNull
}

    from "@/utils/publicMethods"

import {
    ElMessage,
}

    from 'element-plus'

import {
    openLoading,
    fullscreenLoading
}

    from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;

export default defineComponent({
    components: {
        UserHead,
        HeadTop
    }

    ,
    data() {
        return {
            Withdrawal_Conf: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            }

            ,
            Withdrawal_data: [],
            Withdrawal_Dialog: {

                Visible: false,
                from: {

                    money: '',
                    skAct: [{
                        'act': 'wx', 'skm': '', 'str': "微信"
                    }

                        ,
                    {
                        'act': 'zfb', 'skm': '', 'str': "支付宝"
                    }

                        ,
                    ],
                    selectAct: '',
                    remarks: ""
                }

                ,
                maxMoney: 0
            }

            ,
        }
    }

    ,
    methods: {
        getWithdrawalAct(act) {

            //    1:收入，2：支出，3：登录，4，其他
            switch (act) {
                case -1: return "提现驳回"
                case 0: return "等待审核"
                case 1: return "已打款"
                default: return "未知"
            }
        },
        getUserWithdrawal() {
            openLoading();
            const data = new FormData();

            data.append("page", this.Withdrawal_Conf.currentPage);
            data.append("pageSize", this.Withdrawal_Conf.pageSize);
            const headers = {
                'token': localStorage.getItem("token")
            }

            axios.post(baseURL + '/userApi/getUserWithdrawal', data, {
                timeout: 5000, headers

            }).then(res => {

                // isLogin(res)
                if (res.data.code == 200) {
                    this.Withdrawal_data = res.data.data;
                    this.Withdrawal_Conf.total = res.data.total;
                    return;
                }
                else {
                    ElMessage.error(res.data.msg)
                }

                if (res.data.code == 401) {
                    setTimeout(() => {
                        location.href = "/Login"
                    }, 1000);
                }

            }).catch(err => {
                ElMessage.error(err)

            }).finally(() => {
                fullscreenLoading.close()
            })
        },
        getSkm() {
            openLoading();
            const data = new FormData();

            const headers = {
                'token': localStorage.getItem("token")
            }

            axios.post(baseURL + '/userApi/getSkm', data, {
                timeout: 5000, headers

            }).then(res => {
                fullscreenLoading.close();
                isLogin(res);
                if (res.data.code == 200) {
                    this.Withdrawal_Dialog.from.skAct = res.data.data;
                    this.Withdrawal_Dialog.maxMoney = res.data.money;
                }
                else if (res.data.code == 401) {
                    ElMessage.error(res.data.msg);
                    setTimeout(() => {
                        location.href = "/Login"
                    }, 1000);
                }

            }).catch(err => {
                fullscreenLoading.close();
                ElMessage.error(err)
            })
        },
        WithdrawalSizeChange(val) {
            this.Withdrawal_Conf.pageSize = val;
            this.getUserWithdrawal()
        },
        WithdrawalCurrentChange(val) {
            this.Withdrawal_Conf.currentPage = val;
            this.getUserWithdrawal()
        },
        applyWithdrawal(act) {
            console.log("11");

            if (act == 'dialog') {
                this.Withdrawal_Dialog.Visible = true;
                this.getSkm()
            }
            else if (act == 'apply') {
                const data = new FormData();

                data.append("money", this.Withdrawal_Dialog.from.money);
                if (isNull(this.Withdrawal_Dialog.from.money)) {
                    ElMessage.error("请输入提现金额");
                    return
                }

                data.append("act", this.Withdrawal_Dialog.from.selectAct);
                let temp = this.Withdrawal_Dialog.from.skAct.filter(item => item.act == this.Withdrawal_Dialog.from.selectAct);
                if (temp.length == 0) {
                    ElMessage.error("请选择收款信息");
                    return
                }

                data.append("skm", temp[0].skm);
                data.append("remarks", this.Withdrawal_Dialog.from.remarks);
                const headers = {
                    'token': localStorage.getItem("token")
                }

                openLoading();
                axios.post(baseURL + '/userApi/applyWithdrawal', data, {
                    timeout: 5000, headers

                }).then(res => {
                    fullscreenLoading.close();
                    if (res.data.code == 401) {
                        ElMessage.error(res.data.msg);
                        setTimeout(() => {
                            location.href = "/login"
                        }, 1000);
                    }
                    else if (res.data.code == 200) {
                        ElMessage.success(res.data.msg);
                        this.Withdrawal_Dialog.Visible = false;
                        this.getUserWithdrawal()
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }

                }).catch(err => {
                    fullscreenLoading.close();
                    ElMessage.error(err)
                })
            }
        },
        isNull(text) {
            return isNull(text);
        }
    },
    mounted() {
        this.getUserWithdrawal()
    }
})
</script>
